var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-gap-4 tw-bg-white tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-pt-5",class:_vm.fewColumns ? 'tw-columns-[15rem]' : 'tw-columns-[12rem]'},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }